import moment from "moment";

export const constantes = {
    pantalla: {
        imputarHoras: 8,
        validarImputaciones: 10,
        mockUser: 18,
        informeOvertime: 24,
    }
}
async function makeCall(uri, method, parameters) {
    var requestInit = {
        method: method
    };

    if (parameters != null) {
        requestInit.body = JSON.stringify(parameters);
        requestInit.headers = {
            "Content-Type": "application/json; charset=utf-8"
        };
    }

    var userStr = localStorage.getItem("userlogged");

    if (userStr) {
        var user = JSON.parse(userStr);

        if (!requestInit.headers) {
            requestInit.headers = {};
        }

        requestInit.headers["Authorization"] = `Bearer ${user.token}`;

        var response = await fetch(uri, requestInit);

        if (response.status === 401) {
            localStorage.removeItem("userlogged");

            const publicUrl = new URL(process.env.PUBLIC_URL, window.location);
            window.location.href = `${publicUrl.origin}/api/logout`;
        }
        else {
            return response;
        }
    }
    else {
        return await fetch(uri, requestInit);
    }
}

export async function getConfig() {
    return await makeCall("api/config");
}

/* Permisos profesional por pantalla */
export async function getProfessionalPermissions(data) {
    let response = await makeCall(`/api/timesheettasking/Permisos/GetPermisosAcceso`, "POST", data);

    return response.json();
}
/* Fin permisos profesional por pantalla */

/* Login/Logout */
export async function getUserByToken(code) {
    const response = await makeCall(`/api/login/resolve-user?code=${code}`, "GET");
    return await response.json();
}

export async function logout() {
    const response = await makeCall(`/api/login/logout`, "GET");
    return response.json();
}
/* Fin Login/Logout */

/* Persona */
export async function GetPersonaData(language, data) {
    const response = await makeCall(`/api/timesheettasking/reporthours/getpersonadata/${language}`, "POST", data);
    return response.json();
}

export async function GetMockuserData(language, data) {
    const response = await makeCall(`/api/timesheettasking/reporthours/GetMockuserData/${language}`, "POST", data);
    return response.json();
}
/* Fin Persona */

/* Proyecto */
export async function GetParentsProjectsData(language) {
    const response = await makeCall(`/api/timesheettasking/reporthours/getparentsprojectsdata/${language}`, "GET");
    return response.json();
}

export async function GetParentsProjectsDataBySociedad(language, sociedad, nPersonal) {
    const response = await makeCall(`/api/timesheettasking/reporthours/getparentsprojectsdatabysociedad/${language}/${sociedad}/${nPersonal}`, "GET");
    return response.json();
}

//export async function getChildrenProjectsDataByProjectAndSociety(language, id, esProyectoGeneral) {
//    const response = await makeCall(`/api/timesheettasking/reporthours/GetChildrenProjectsDataByProjectAndSociety/${language}/${id}/${esProyectoGeneral}`, "GET");
//    return response.json();
//}

export async function getChildrenProjectsDataByProjectSocietyAndEmplazamiento(language, id, sociedad, esProyectoGeneral, nPersonal) {
    const response = await makeCall(`/api/timesheettasking/reporthours/getChildrenProjectsDataByProjectSocietyAndEmplazamiento/${language}/${id}/${sociedad}/${esProyectoGeneral}/${nPersonal}`, "GET");
    return response.json();
}

export async function GetProjectDataByIdPep(language, id) {
    const response = await makeCall(`/api/timesheettasking/reporthours/getprojectdatabyidpep/${language}/${id}`, "GET");
    return response.json();
}
/* Fin Proyecto */

/* Periodos */
export async function GetPeriodByDate(language, date) {
    date = FormatDate(date);

    const response = await makeCall(`/api/timesheettasking/reporthours/getperiodbydate/${language}/${date}`, "GET");
    return response.json();
}

export async function GetPeriodsBySociety(language, society) {
    const response = await makeCall(`/api/timesheettasking/reporthours/getperiodsbysociety/${language}/${society}`, "GET");
    return response.json();
}

export async function GetPeriodByStartDateAndEndDate(language, startDate, endDate) {
    var from = FormatDate(startDate);
    var to = FormatDate(endDate);

    const response = await makeCall(`/api/timesheettasking/reporthours/getperiodbystartdateandenddate/${language}/${from}/${to}`, "GET");
    return response.json();
}
/* Fin Periodos */


/* Imputaciones */
export async function GetLabourCodes(language) {
    const response = await makeCall(`/api/timesheettasking/reporthours/GetLabourCodes/${language}`, "GET");
    return response.json();
}

export async function GetEmployeeImputation(language, data, periodo) {
    var json_data = JSON.stringify(data);
    var json_periodo = JSON.stringify(periodo);

    var json = [json_data, json_periodo];

    const response = await makeCall(`/api/timesheettasking/reporthours/getemployeeimputation/${language}`, "POST", json);
    return response.json();
}

export async function SaveEmployeeImputation(language, req, data) {
    var json_req = JSON.stringify(req);
    var json_data = JSON.stringify(data);

    var json = [json_req, json_data];

    const response = await makeCall(`/api/timesheettasking/reporthours/saveemployeeimputation/${language}`, "POST", json);
    return response.json();
}

export async function IsEmployeeSubordinateOf(language, req) {
    var json_req = JSON.stringify(req);

    var json = [json_req];

    const response = await makeCall(`/api/timesheettasking/reporthours/IsEmployeeSubordinateOf/${language}`, "POST", json);
    return response.json();
}
/* Fin Imputaciones */

/* Mánager */
export async function GetTeam(language, data, startDate, endDate) {
    const response = await makeCall(`/api/timesheettasking/validatehours/getteam/${language}/${startDate}/${endDate}`, "POST", data);
    return response.json();
}

export async function GetProfessionalHours(data, NPersonal, startDate, endDate) {
    const response = await makeCall(`/api/timesheettasking/validatehours/GetProfessionalImputedHours/${NPersonal}/${startDate}/${endDate}`, "POST", data);
    return response.json();
}

export async function GetValidateHoursPendingFlag(data, NPersonal, startDate, endDate) {
    const response = await makeCall(`/api/timesheettasking/validatehours/GetValidateHoursPendingFlag/${NPersonal}/${startDate}/${endDate}`, "POST", data);
    return response.json();
}

export async function ValidateProfessionalImputedHours(data, NPersonal, startDate, endDate) {
    const response = await makeCall(`/api/timesheettasking/validatehours/ValidateProfessionalImputedHours/${NPersonal}/${startDate}/${endDate}`, "POST", data);
    return response.json();
}
/* Fin mánager */

/* Mockup */
export async function MockupGetTeam(language, data, startDate, endDate) {
    const response = await makeCall(`/api/timesheettasking/mockup/getteam/${language}/${startDate}/${endDate}`, "POST", data);
    return response.json();
}

export async function MockupGetProfessionalHours(data, NPersonal, startDate, endDate) {
    const response = await makeCall(`/api/timesheettasking/mockup/GetProfessionalImputedHours/${NPersonal}/${startDate}/${endDate}`, "POST", data);
    return response.json();
}

export async function MockupGetValidateHoursPendingFlag(data, NPersonal, startDate, endDate) {
    const response = await makeCall(`/api/timesheettasking/mockup/GetValidateHoursPendingFlag/${NPersonal}/${startDate}/${endDate}`, "POST", data);
    return response.json();
}

export async function MockupSaveEmployeeImputation(language, req, data) {
    var json_req = JSON.stringify(req);
    var json_data = JSON.stringify(data);

    var json = [json_req, json_data];

    const response = await makeCall(`/api/timesheettasking/mockup/SaveEmployeeImputation/${language}`, "POST", json);
    return response.json();
}
/* Fin Mockup */
/* Informes */
export async function GetReport1File(req, fechaInicio, fechaFin, language, data) {
    var json_req = JSON.stringify(req);
    var json_periodo = JSON.stringify({ FechaInicio: fechaInicio, FechaFin: fechaFin });
    var json_data = JSON.stringify(data);

    var json = [json_req, json_periodo, json_data];

    const response = await makeCall(`/api/timesheettasking/reports/GetReport1File/${language}`, "POST", json);
    return response;
}

export async function GetReport1Data(language, req, fechaInicio, fechaFin, data) {
    var json_req = JSON.stringify(req);
    var json_periodo = JSON.stringify({ FechaInicio: fechaInicio, FechaFin: fechaFin });
    var json_data = JSON.stringify(data);

    var json = [json_req, json_periodo, json_data];

    const response = await makeCall(`/api/timesheettasking/reports/GetReport1Data/${language}`, "POST", json);
    return response.json();
}

export async function GetOvertimeEmployeeFile(req, fechaInicio, fechaFin, language, data) {
    var json_req = JSON.stringify(req);
    var json_periodo = JSON.stringify({ FechaInicio: fechaInicio, FechaFin: fechaFin });
    var json_data = JSON.stringify(data);

    var json = [json_req, json_periodo, json_data];

    const response = await makeCall(`/api/timesheettasking/OvertimeEmployee/GetOvertimeEmployeeFile/${language}`, "POST", json);
    return response;
}

export async function GetReportOvertimeEmployeeData(language, req, fechaInicio, fechaFin, data) {
    var json_req = JSON.stringify(req);
    var json_periodo = JSON.stringify({ FechaInicio: fechaInicio, FechaFin: fechaFin });
    var json_data = JSON.stringify(data);

    var json = [json_req, json_periodo, json_data];

    const response = await makeCall(`/api/timesheettasking/OvertimeEmployee/GetReportOvertimeEmployeeData/${language}`, "POST", json);
    return response.json();
}

export async function GetReportUtilisationFile(req, fechaInicio, fechaFin, language, data) {
    var json_req = JSON.stringify(req);
    var json_periodo = JSON.stringify({ FechaInicio: fechaInicio, FechaFin: fechaFin });
    var json_data = JSON.stringify(data);
    var json = [json_req, json_periodo, json_data];

    const response = await makeCall(`/api/timesheettasking/Utilisation/GetReportUtilisationFile/${language}`, "POST", json);
    return response;
}

export async function GetReportUtilisationData(language, req, fechaInicio, fechaFin, data) {
    var json_req = JSON.stringify(req);
    var json_periodo = JSON.stringify({ FechaInicio: fechaInicio, FechaFin: fechaFin });
    var json_data = JSON.stringify(data);

    var json = [json_req, json_periodo, json_data];

    const response = await makeCall(`/api/timesheettasking/Utilisation/GetReportUtilisationData/${language}`, "POST", json);
    return response.json();
}

export async function GetReportExternalEmployeeImputationsData(language, req, fechaInicio, fechaFin, data) {
    var json_req = JSON.stringify(req);
    var json_periodo = JSON.stringify({ FechaInicio: fechaInicio, FechaFin: fechaFin });
    var json_data = JSON.stringify(data);

    var json = [json_req, json_periodo, json_data];

    const response = await makeCall(`/api/timesheettasking/ExternalEmployeeImputations/GetReportData/${language}`, "POST", json);
    return response.json();
}

export async function GetReportExternalEmployeeImputationsFile(language, req, fechaInicio, fechaFin, data) {
    var json_req = JSON.stringify(req);
    var json_periodo = JSON.stringify({ FechaInicio: fechaInicio, FechaFin: fechaFin });
    var json_data = JSON.stringify(data);

    var json = [json_req, json_periodo, json_data];

    const response = await makeCall(`/api/timesheettasking/ExternalEmployeeImputations/GetReportFile/${language}`, "POST", json);
    return response;
}

export async function GetReportTeamHoursFile(language, req, fechaInicio, fechaFin) {
    var json_req = JSON.stringify(req);
    var json_periodo = JSON.stringify({ FechaInicio: fechaInicio, FechaFin: fechaFin });

    var json = [json_req, json_periodo];

    const response = await makeCall(`/api/timesheettasking/ValidateHours/GetReportFile/${language}`, "POST", json);
    return response;
}

export async function GetPeriodos(language, req) {
    var json_req = JSON.stringify(req);
    //var json_data = JSON.stringify(data);

    var json = [json_req];

    const response = await makeCall(`/api/timesheettasking/reports/GetPeriodos/${language}`, "POST", json);
    return response.json();
}

export async function GetDatosInicialesReport1(language, req) {
    var json_req = JSON.stringify(req);
    //var json_data = JSON.stringify(data);

    var json = [json_req];

    const response = await makeCall(`/api/timesheettasking/reports/GetDatosIniciales/${language}`, "POST", json);
    return response.json();
}

export async function GetReportQHSEFile(req, fechaInicio, fechaFin, language, data) {
    var json_req = JSON.stringify(req);
    var json_periodo = JSON.stringify({ FechaInicio: fechaInicio, FechaFin: fechaFin });
    var json_data = JSON.stringify(data);
    var json = [json_req, json_periodo, json_data];

    const response = await makeCall(`/api/timesheettasking/QHSE/GetReportFile/${language}`, "POST", json);
    return response;
}

export async function GetReportQHSEData(language, req, fechaInicio, fechaFin, data) {
    var json_req = JSON.stringify(req);
    var json_periodo = JSON.stringify({ FechaInicio: fechaInicio, FechaFin: fechaFin });
    var json_data = JSON.stringify(data);

    var json = [json_req, json_periodo, json_data];

    const response = await makeCall(`/api/timesheettasking/QHSE/GetReportData/${language}`, "POST", json);
    return response.json();
}

export async function GetDatosInicialesQHSE(language, req) {
    var json_req = JSON.stringify(req);
    //var json_data = JSON.stringify(data);

    var json = [json_req];

    const response = await makeCall(`/api/timesheettasking/QHSE/GetDatosIniciales/${language}`, "POST", json);
    return response.json();
}
/* Fin Informes */

/* Admin */
// Admin periodos.
export async function GetAdminPeriodosCatalogo(language, req) {
    var json_req = JSON.stringify(req);
    //var json_data = JSON.stringify(data);

    var json = [json_req];

    const response = await makeCall(`/api/timesheettasking/AdminPeriodos/Get/${language}`, "POST", json);
    return response.json();
}

export async function SetAdminPeriodo(req, periodo) {
    var json = [];
    json.push(JSON.stringify(req));
    json.push(JSON.stringify(periodo));

    const response = await makeCall('/api/timesheettasking/AdminPeriodos/Set/', 'POST', json);

    return response.json();
}

/* Fin admin */

/* Traducciones */
export async function GetLabelsByController(language, controller_name) {
    const response = await makeCall(`/api/permisosaplicaciones/traducciones/getlabelsbycontroller/${language}/${controller_name}`, "POST");
    return response.json();
};

export async function GetLabelsByFolderAndController(language, folder_name, controller_name) {
    const response = await makeCall(`/api/permisosaplicaciones/traducciones/getlabelsbyfolderandcontroller/${language}/${folder_name}/${controller_name}`, "POST");
    return response.json();
};

export async function GetLabelsByLabelName(language, controller_name) {
    const response = await makeCall(`/api/PermisosAplicaciones/Traducciones/GetLabelsByLabelName/${language}/${controller_name}`, "POST");
    return response.json();
};

export async function GetLabelsByFolderAndControllerAndLabelName(language, folder_name, controller_name, label_name) {
    const response = await makeCall(`/api/permisosaplicaciones/traducciones/getlabelsbyfolderandcontrollerandlabelname/${language}/${folder_name}/${controller_name}/${label_name}`, "POST");
    return response.json();
};

export async function GetTranslationsByLabels(language, labels) {
    const response = await makeCall(`/api/permisosaplicaciones/traducciones/gettranslationsbylabels/${language}`, "POST", labels);
    return response.json();
};
/* Fin Traducciones */

/* Menu */
export async function GetMenu(token) {
    const response = await makeCall("/api/permisosaplicaciones/menu/getmenu", "POST", token);
    return response.ok ? await response.json() : null;
}
/* Fin Menu */

/* Utils */
function FormatDate(date) {
    var newDate = new Date(date); // Aquí debes obtener la fecha que deseas enviar
    var formatDate = newDate.toISOString().split('T')[0];

    return formatDate;

}
/* Fin Utils */